export enum OnboardingStep {
	Welcome = 'welcome',
	NoMoreRepetitiveQuestions = 'noMoreRepetitiveQuestions',
	GainMoreContext = 'gainMoreContext',
	ChromeExtension = 'chromeExtension',
	AskAi = 'askAi',
}

export interface OnboardingPage {
	title: (firstName: string) => string;
	text: (workspaceName: string) => string;
	image: {
		src: string;
		alt: string;
		style: {
			top?: string;
			right?: string;
			left?: string;
			width?: string;
			position?: 'relative' | 'absolute';
		};
	};
}

export const ONBOARDING_PAGES: Record<OnboardingStep, OnboardingPage> = {
	[OnboardingStep.Welcome]: {
		title: (firstName) =>
			`Hi${firstName ? ` ${firstName}` : ''},\nwelcome to Secoda`,
		text: (workspaceName) =>
			`Your Google search for ${workspaceName}’s data, improving transparency for your cross-functional team.`,
		image: {
			src: '/images/onboarding/education_1_4x.webp',
			alt: "An example of Secoda's search UI",
			style: {
				top: '5%',
				right: '0',
				width: '90%',
				position: 'absolute',
			},
		},
	},
	[OnboardingStep.NoMoreRepetitiveQuestions]: {
		title: () => 'No more repetitive questions',
		text: () =>
			'Bridge the gap of data insights by asking your data team questions or reviewing past questions. Your data team can provide links to relevant tables, queries, or additional questions for clearer insights.',
		image: {
			src: '/images/onboarding/education_2_4x.webp',
			alt: "An example of Secoda's AI Assistant",
			style: {
				top: '15%',
				left: '5%',
				width: '90%',
				position: 'absolute',
			},
		},
	},
	[OnboardingStep.GainMoreContext]: {
		title: () => 'Gain more context about your data',
		text: () =>
			'Understand your data better through Secoda by discovering information like descriptions, owners, related resources, and more.',
		image: {
			src: '/images/onboarding/education_3_4x.webp',
			alt: "An example of your company's data within Secoda",
			style: {
				top: '2%',
				left: '5%',
				width: '90%',
				position: 'absolute',
			},
		},
	},
	[OnboardingStep.ChromeExtension]: {
		title: () => 'Add Secoda to Chrome',
		text: () =>
			'Get the most out of Secoda with our new Google Chrome extension. Access and maintain metadata directly in tools like Sigma, Tableau, and Looker. Ask Secoda AI and your data team questions directly from Chrome. Quickly search across all your resources in one place.',
		image: {
			src: '/images/onboarding/education_4_4x.webp',
			alt: 'An example of Secoda in Chrome',
			style: {
				top: '9%',
				left: '5%',
				width: '90%',
				position: 'absolute',
			},
		},
	},
	[OnboardingStep.AskAi]: {
		title: () => 'Get started with a question',
		text: () =>
			'What’s something you’re curious about in your data today? Ask anything, and we’ll help you find the answer right away.',
		image: {
			src: '/images/onboarding/onboarding-ai.webp',
			alt: 'An example of the Secoda AI chat',
			style: {
				top: '0',
				left: '0',
				width: '100%',
				position: 'absolute',
			},
		},
	},
};
